import { jsx as _jsx } from "react/jsx-runtime";
import ErrorDisplay from './ErrorDisplay';
import PageLoadingIndicator from './PageLoadingIndicator';
export default function LoadQueryWrapper(useLoadData, WrappedComponent) {
    const Wrapper = (props) => {
        const { data, loading, error } = useLoadData({});
        if (loading) {
            return _jsx(PageLoadingIndicator, { visible: true });
        }
        if (error) {
            return _jsx(ErrorDisplay, { graphQLError: error });
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return _jsx(WrappedComponent, Object.assign({ data: data }, props));
    };
    const wrappedComponentDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    Wrapper.displayName = `LoadQueryWrapper<${wrappedComponentDisplayName}>`;
    return Wrapper;
}
//# sourceMappingURL=LoadQueryWrapper.js.map